import { DOCUMENT_TYPES } from '../../../constants/purchase';
import { PurchaseFormValues } from '../../../types/purchases/BasePurchase';
import { mapExcludedSubjectPurchase } from './excludedSubjectMapper';
import { mapTaxCreditPurchase } from './taxCreditMapper';
import { mapImportPurchase } from '../../../utils/mappers/purchases/importMapper';
import { mapDebitNotePurchase } from './debitNoteMapper';
import { mapCreditNotePurchase } from './creditNoteMapper';
import { PurchaseFinalizeDTO } from './types';

export const PurchaseFinalizeMappers: Record<number, (form: PurchaseFormValues) => PurchaseFinalizeDTO> = {
  [DOCUMENT_TYPES.TAX_CREDIT]: mapTaxCreditPurchase,
  [DOCUMENT_TYPES.IMPORT]: mapImportPurchase,
  [DOCUMENT_TYPES.DEBIT_NOTE]: mapDebitNotePurchase,
  [DOCUMENT_TYPES.CREDIT_NOTE]: mapCreditNotePurchase,
  [DOCUMENT_TYPES.EXCLUDED_SUBJECT]: mapExcludedSubjectPurchase,
};

export const mapPurchaseToFinalizeDTO = (form: PurchaseFormValues): PurchaseFinalizeDTO => {
  const documentTypeId = form.documentType?.id;

  const mapper = documentTypeId ? PurchaseFinalizeMappers[documentTypeId] : null;

  if (!mapper) {
    throw new Error('❌ Tipo de documento no soportado para finalizar la compra.');
  }

  return mapper(form);
};
